// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1niMQ","rightAdornment":"Header_rightAdornment__1o2Q1"};